function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';
var uuidv4 = require('uuid/v4');
var _ = require('lodash');
import RichTextEditor from 'react-rte';
import { convertToRaw, ContentState, EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToMarkdown from 'draftjs-to-markdown';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './RXRichText.css';
var logdown = require('logdown');
var console = logdown('rx-forms-rx-richtext', { prefixColor: '#0288d1' });

var RXRichText = function (_Component) {
    _inherits(RXRichText, _Component);

    function RXRichText(props) {
        _classCallCheck(this, RXRichText);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.parseValue = function (value) {
            var focus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


            var contentBlock = htmlToDraft(value);

            _this.setState({ temporaryContent: value }, function () {

                if (contentBlock) {
                    var contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                    var editorState = EditorState.createWithContent(contentState);
                    if (focus) {
                        editorState = EditorState.moveFocusToEnd(editorState);
                    }
                    _this.setState({ editorState: editorState });
                }
            });
        };

        _this.onEditorStateChange = function (editorState) {
            _this.setState({
                editorState: editorState
            });
            console.log('in editor state: ', _this.state.editorState);
        };

        _this.onContentStateChange = function (contentState) {

            console.log('in content state: ', contentState);
            var content = draftToHtml(convertToRaw(_this.state.editorState.getCurrentContent()));
            console.log('new content:#', content, '# old:#', _this.state.temporaryContent, "#");
            if (content != _this.state.temporaryContent) {
                console.log('force update state');
                _this.props.onChange({ target: { value: content, id: _this.props.name } });
            }
        };

        _this.doOnChange = function (values) {
            _this.props.onChange({ target: { value: values, id: _this.props.name } });
        };

        _this.onChange = function (value) {
            _this.setState({ value: value });
            // if (this.props.onChange) {
            //     // Send the changes up to the parent component as an HTML string.
            //     // This is here to demonstrate using `.toString()` but in a real app it
            //     // would be better to avoid generating a string on each change.
            //     this.props.onChange(
            //         value.toString('html')
            //     );
            // }
        };

        _this.state = {
            invalid: false,
            value: _this.props.value ? _this.props.value : "",
            editorState: undefined,
            contentState: undefined,
            temporaryContent: ""
        };

        console.log('in richtext');
        return _this;
    }

    RXRichText.prototype.componentDidMount = function componentDidMount() {
        this.parseValue(this.state.value);
    };

    RXRichText.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {

        if (this.props.data != prevProps.data) {
            this.setState({ data: this.props.data });
        }
        if (this.props.value != prevProps.value) {
            if (_.isObject(this.props.value)) {
                this.parseValue(this.props.value.new, true);
            }
            console.log('try to update with ', this.props.value);
            this.setState({ temporaryContent: this.props.value });
            //this.setState({value: this.props.value});
        }
        // if(this.props.transformers[this.props.name] != prevProps.transformers[this.props.name]){            
        //   this.setState({transformer: this.props.transformers[this.props.name]})  
        // }
    };

    RXRichText.prototype.render = function render() {

        // console.log(`in render with `, this.props);
        var props = _.omit(this.props, 'onFileAdded');

        var value = props.value,
            props = _objectWithoutProperties(props, ['value']);

        var innerValue = value;
        if (this.state.transformer) {
            innerValue = this.state.transformer(value);
        }

        return React.createElement(
            React.Fragment,
            null,
            React.createElement(Editor, {
                wrapperClassName: 'demo-wrapper',
                editorClassName: 'demo-editor',
                wrapperStyle: { border: "1px solid #ced4da", "borderRadius": ".25rem" },
                onEditorStateChange: this.onEditorStateChange,
                onContentStateChange: this.onContentStateChange,
                editorState: this.state.editorState,
                editorStyle: { minHeight: this.props.minHeight, paddingLeft: 10, paddingRight: 10 }
            })
        );
    };

    return RXRichText;
}(Component);

RXRichText.defaultProps = {
    minHeight: 300
};

export default RXRichText;